import React from 'react'

// Configure your footer text here
const FOOTER_CONFIG = {
  copyrightYear: 2026,
  companyName: 'Halyard Analytics LLC',
  companyUrl: 'https://halyardanalytics.com/',
  rightsText: 'All Rights Reserved'
}

export const Footer: React.FC = () => {
  return (
    <footer style={{
      textAlign: 'center',
      padding: '1rem',
      marginTop: '2rem',
      borderTop: '1px solid #e9ebed',
      color: '#5f6b7a',
      fontSize: '0.875rem'
    }}>
      © {FOOTER_CONFIG.copyrightYear}{' '}
      <a href={FOOTER_CONFIG.companyUrl} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
        {FOOTER_CONFIG.companyName}
      </a>. {FOOTER_CONFIG.rightsText}.
    </footer>
  )
}
